import { useStableReducer } from '@/hooks/useStable';
import { AccessLevel, Device, MetaPageType, PageType } from '@/types/app';
import { Component } from '@/types/component';
import { PaymentConfig, PaymentConfigV2 } from '@/types/payment';
import { RecommendedArticle, ScrollArticle } from 'lib/data/recommendations';
import { Dispatch, createContext } from 'react';
import { UserInfo } from '@/types/userInfo';

export interface AppState extends Record<string | number, any> {
  accessLevel?: AccessLevel;
  affiliate?: string;
  alltIdUserCode?: string;
  category?: string;
  device: Device;
  gamesUrls?: string[];
  isArticlePage: boolean;
  isDesktop: boolean;
  isFrontPage: boolean;
  isMobile: boolean;
  isNativeAd?: boolean;
  isPreviewPage: boolean;
  isVevArticle?: boolean;
  metaPageType?: MetaPageType;
  pageId?: number;
  publishedUrl?: string;
  purchaseTag?: string;
  recommendedArticles: RecommendedArticle[];
  scrollArticles: ScrollArticle[];
  paymentConfig?: PaymentConfig | PaymentConfigV2;
  type: PageType;
  frisbiiSession?: {
    sessionId?: string;
    signature?: string;
    customer?: string;
    subscription?: string;
    purchaseCompleted?: boolean;
  };
  userInfo?: UserInfo;
}

export type AppStateValue = [AppState, Dispatch<Partial<AppState>>];

export const AppStateContext = createContext<AppStateValue>([{} as AppState, () => {}]);

export const AppStateProvider: Component<AppState> = ({ children, ...initialPageState }) => {
  const value = useStableReducer((state: AppState, update: Partial<AppState>) => {
    return { ...state, ...update };
  }, initialPageState as AppState);

  return <AppStateContext.Provider value={value}>{children}</AppStateContext.Provider>;
};
